import React, { useId } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import CloseIcon from '@mui/icons-material/Close'
import DropdownSelect from '../../pages/components/DropdownSelect'

type PopoverSelectorProps<T extends { readonly id: string; label: string } = { readonly id: string; label: string }> = {
    anchorEl: Element
    label: string
    onChange: (v: T['id'][]) => void
    onClose: () => void
    options: Array<T>
    selectedId: Array<T['id']>
}

export const PopoverSelector = <T extends { readonly id: string; readonly label: string }>({
    anchorEl,
    label,
    onChange,
    onClose,
    options,
    selectedId,
}: PopoverSelectorProps<T>) => {
    const popoverId = useId()

    return (
        <Popover
            id={popoverId}
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <Card>
                <CardHeader
                    action={
                        <IconButton disableRipple onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                    subheader={label}
                />
                <Box
                    sx={{
                        px: 4,
                        pb: 4,
                    }}
                >
                    <DropdownSelect items={options} selectedItems={selectedId} onChange={onChange} />
                </Box>
            </Card>
        </Popover>
    )
}
